import React, { useState, Component, useRef } from 'react';
import { Form, Row, Col, FormGroup, Label, Input, Button, Modal, ModalHeader, ModalBody, ModalFooter, FormFeedback } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import authService from '../api-authorization/AuthorizeService'
import debounce from 'lodash.debounce';


export class PaletizadosView extends Component {
    constructor(props) {
        console.log("props",props)
        super(props);
        var rawUrl = window.location.toString();
        var contenedorSemanal_Id = rawUrl.split("ContenedoresSemanales/")[1].split("/")[0];
        this.state = {
            operation: props.operation,
            etiquetasCore: [],
            calibres: [],
            cajasPorPaleta: [],
            contenedorSemanal: {}
        };
        if (props.data) {
            this.state.model = props.data;
            this.state.model.fechaDeCosecha = new Date(this.state.model.fechaDeCosecha).toISOString().substring(0, 10);
            this.state.model.fechaDeEmpaque = new Date(this.state.model.fechaDeEmpaque).toISOString().substring(0, 10);
        }
        if (props.contenedorSemanal) {
            this.state.contenedorSemanal = props.contenedorSemanal;
        }
        else {
            this.state.model = {
                contenedorSemanal_Id: contenedorSemanal_Id,
                etiquetaCore_Id: 0,
                calibre_Id: 0,
                cajasPorPaleta_Id: 0,
                carton: "",
                fechaDeCosecha: new Date().toISOString().substring(0, 10),
                fechaDeEmpaque: new Date().toISOString().substring(0, 10),
                codigoTMU: "",
                comentarios: "",
                finca: "",
                rechazo: 0
            };
        }
        console.log(" this.state.model", this.state.model)
        this.state.modelValidation = {
            vaporSemanal_Id: this.state.model.vaporSemanal_Id != 0,
            destino_Id: this.state.model.destino_Id != 0,
            contenedor_Id: this.state.model.contenedor_Id != 0,
            etiquetaEspecial: this.state.model.etiquetaEspecial != "",
        }
        this.handleChange = this.handleChange.bind(this);
        this.validate = this.validate.bind(this);
        this.validate = debounce(this.validate, 1000);
        this.load_etiquetasCore = this.load_etiquetasCore.bind(this);
        this.load_calibres = this.load_calibres.bind(this);
        this.load_cajasPorPaleta = this.load_cajasPorPaleta.bind(this);
        this.populateData = this.populateData.bind(this);
    }

    async handleChange(event) {

        var tempModel = this.state.model;
        tempModel[event.target.name] = event.target.value;
        //if (event.target.name == "codigoTMU") {
        //    // Remove non-numeric characters
        //    var numericValue = event.target.value.replace(/\D/g, '');

        //    // Ensure the value is an integer with no leading zeros
        //    var integerValue = parseInt(numericValue, 10);

        //    // Limit the length to a maximum of 10 characters

        //    tempModel[event.target.name] = isNaN(integerValue) ? "" : integerValue.toString().slice(0, 10)
        //}
        this.setState({
            model: tempModel
        }, async () => {
            
            this.props.setModalBodyState(this.state).then(() => this.validate());
        });
        
    }
    async validate() {
        const token = await authService.getAccessToken();
        var model = this.state.model;
        model.fechaDeCosecha = model.fechaDeCosecha != "" ? model.fechaDeCosecha : null;
        model.fechaDeEmpaque = model.fechaDeEmpaque != "" ? model.fechaDeEmpaque : null;
        const data = JSON.stringify(model);
        const response = await fetch('api/paletizados/validate', {
            method: 'POST',
            headers: !token ? { 'Content-Type': 'application/json' } : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
            body: data
        });
        if (response.ok) {
            var validations = await response.json();
            this.setState({
                modelValidation: validations
            }, () => {
                this.props.setModalBodyState(this.state);
            });
        }
    }
    getValidationValue(value) {
        if (value == null || value == undefined) {
            return true;
        }
        else {
            return value;
        }
    }
    
    render() {
        var hideCalibre = this.state.contenedorSemanal.producto == "Banano";
        hideCalibre = false;
        return (
            <div >
                <Row>
                    <Form>
                        <Row>
                            <Col>
                                <FormGroup>
                                    <Label for="etiquetaCore_Id">
                                        <FormattedMessage id='EtiquetaCore' />
                                    </Label>
                                    <Input
                                        id="etiquetaCore_Id"
                                        name="etiquetaCore_Id"
                                        type="select"
                                        onChange={this.handleChange}
                                        valid={this.getValidationValue(this.state.modelValidation.etiquetaCore_Id)}
                                        invalid={!this.getValidationValue(this.state.modelValidation.etiquetaCore_Id)}
                                    >
                                        <option value="0"></option>
                                        {this.state.etiquetasCore.map(etiquetaCore => etiquetaCore.etiquetaCore_Id == this.state.model.etiquetaCore_Id ? (
                                            <option value={etiquetaCore.etiquetaCore_Id} selected>
                                                {etiquetaCore.nombre}
                                            </option>
                                        ) : (<option value={etiquetaCore.etiquetaCore_Id}>{etiquetaCore.nombre}</option>))}
                                    </Input>
                                    <FormFeedback>
                                        {this.state.model.etiquetaCore_Id == 0 ? <FormattedMessage id='Este campo es requerido' /> : ""}
                                    </FormFeedback>
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup>
                                    <Label for="carton">
                                        <FormattedMessage id='Carton' />
                                    </Label>
                                    <FormattedMessage id='Carton'>
                                        {(placeholder) =>
                                            <Input
                                                id="carton"
                                                name="carton"
                                                //placeholder={placeholder}
                                                type="text"
                                                value={this.state.model.carton}
                                                readonly
                                            />
                                        }
                                    </FormattedMessage>

                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <FormGroup>
                                    <Label for="calibre_Id">
                                        <FormattedMessage id='Calibre' />
                                    </Label>
                                    <Input
                                        disabled={hideCalibre}
                                        id="calibre_Id"
                                        name="calibre_Id"
                                        type="select"
                                        onChange={this.handleChange}
                                        valid={!hideCalibre && this.getValidationValue(this.state.modelValidation.calibre_Id)}
                                        invalid={!hideCalibre && !this.getValidationValue(this.state.modelValidation.calibre_Id)}
                                    >
                                        <option value="0"></option>
                                        {this.state.calibres.map(calibre => calibre.calibre_Id == this.state.model.calibre_Id ? (
                                            <option value={calibre.calibre_Id} selected>
                                                {calibre.calibre}
                                            </option>
                                        ) : (<option value={calibre.calibre_Id}>{calibre.calibre}</option>))}
                                    </Input>
                                    <FormFeedback>
                                        {this.state.model.calibre_Id == 0 ? <FormattedMessage id='Este campo es requerido' /> : ""}
                                    </FormFeedback>
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup>
                                    <Label for="cajasPorPaleta_Id">
                                        <FormattedMessage id='Cajas por paleta' />
                                    </Label>
                                    <Input
                                        id="cajasPorPaleta_Id"
                                        name="cajasPorPaleta_Id"
                                        type="select"
                                        onChange={this.handleChange}
                                        valid={this.getValidationValue(this.state.modelValidation.cajasPorPaleta_Id)}
                                        invalid={!this.getValidationValue(this.state.modelValidation.cajasPorPaleta_Id)}
                                    >
                                        <option value="0"></option>
                                        {this.state.cajasPorPaleta.map(cajasPorPaleta => cajasPorPaleta.cajasPorPaleta_Id == this.state.model.cajasPorPaleta_Id ? (
                                            <option value={cajasPorPaleta.cajasPorPaleta_Id} selected>
                                                {cajasPorPaleta.cantidad}
                                            </option>
                                        ) : (<option value={cajasPorPaleta.cajasPorPaleta_Id}>{cajasPorPaleta.cantidad}</option>))}
                                    </Input>
                                    <FormFeedback>
                                        {this.state.model.cajasPorPaleta_Id == 0 ? <FormattedMessage id='Este campo es requerido' /> : ""}
                                    </FormFeedback>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <FormGroup>
                                    <Label for="fechaDeCosecha">
                                        <FormattedMessage id='Fecha de cosecha' />
                                    </Label>
                                    <FormattedMessage id='FechaDeCosecha'>
                                        {(placeholder) =>
                                            <Input
                                                id="fechaDeCosecha"
                                                name="fechaDeCosecha"
                                                //placeholder={placeholder}
                                                type="date"
                                                onChange={this.handleChange}
                                                value={this.state.model.fechaDeCosecha}
                                                valid={this.getValidationValue(this.state.modelValidation.fechaDeCosecha)}
                                                invalid={!this.getValidationValue(this.state.modelValidation.fechaDeCosecha)}
                                            />
                                        }
                                    </FormattedMessage>
                                    <FormFeedback>
                                        {this.state.model.fechaDeCosecha == '' ? <FormattedMessage id='Este campo es requerido' /> : ""}
                                    </FormFeedback>
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup>
                                    <Label for="fechaDeEmpaque">
                                        <FormattedMessage id='Fecha de empaque' />
                                    </Label>
                                    <FormattedMessage id='FechaDeEmpaque'>
                                        {(placeholder) =>
                                            <Input
                                                id="fechaDeEmpaque"
                                                name="fechaDeEmpaque"
                                                //placeholder={placeholder}
                                                type="date"
                                                onChange={this.handleChange}
                                                value={this.state.model.fechaDeEmpaque}
                                                valid={this.getValidationValue(this.state.modelValidation.fechaDeEmpaque)}
                                                invalid={!this.getValidationValue(this.state.modelValidation.fechaDeEmpaque)}
                                            />
                                        }
                                    </FormattedMessage>
                                    <FormFeedback>
                                        {this.state.model.fechaDeEmpaque == '' ? <FormattedMessage id='Este campo es requerido' /> : ""}
                                    </FormFeedback>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <FormGroup>
                                    <Label for="codigoTMU">
                                        <FormattedMessage id='Código TMU' />
                                    </Label>
                                    <FormattedMessage id='CodigoTMU'>
                                        {(placeholder) =>
                                            <Input
                                                id="codigoTMU"
                                                name="codigoTMU"
                                                //placeholder={placeholder}
                                                type="text"
                                                onChange={this.handleChange}
                                                value={this.state.model.codigoTMU}
                                                valid={this.getValidationValue(this.state.modelValidation.codigoTMU)}
                                                invalid={!this.getValidationValue(this.state.modelValidation.codigoTMU)}
                                            />
                                        }
                                    </FormattedMessage>
                                    <FormFeedback>
                                        {this.state.model.codigoTMU == '' ? <FormattedMessage id='Este campo es requerido' /> : <FormattedMessage id='Este codigo ya esta siendo usado' />}
                                    </FormFeedback>
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup>
                                    <Label for="finca">
                                        <FormattedMessage id='Finca' />
                                    </Label>
                                    <FormattedMessage id='Finca'>
                                        {(placeholder) =>
                                            <Input
                                                id="finca"
                                                name="finca"
                                                //placeholder={placeholder}
                                                type="text"
                                                onChange={this.handleChange}
                                                value={this.state.model.finca}
                                                valid={this.getValidationValue(this.state.modelValidation.finca)}
                                                invalid={!this.getValidationValue(this.state.modelValidation.finca)}
                                            />
                                        }
                                    </FormattedMessage>
                                    <FormFeedback>
                                        {this.state.model.finca == '' ? <FormattedMessage id='Este campo es requerido' /> : ''}
                                    </FormFeedback>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col >
                                <FormGroup>
                                    <Label for="rechazo">
                                        <FormattedMessage id='Rechazo' />
                                    </Label>
                                    <Input
                                        id="rechazo"
                                        name="rechazo"
                                        type="number"
                                        onChange={this.handleChange}
                                        value={this.state.model.rechazo}
                                    />
                                </FormGroup>
                            </Col>
                            <Col></Col>
                        </Row>
                        <Row>
                            <Col>
                                <FormGroup>
                                    <Label for="comentarios">
                                        <FormattedMessage id='Comentarios' />
                                    </Label>
                                    <FormattedMessage id='Comentarios'>
                                        {(placeholder) =>
                                            <Input
                                                id="comentarios"
                                                name="comentarios"
                                                //placeholder={placeholder}
                                                type="text"
                                                onChange={this.handleChange}
                                                value={this.state.model.comentarios}
                                            />
                                        }
                                    </FormattedMessage>
                                </FormGroup>
                            </Col>
                        </Row>
                        
                    </Form>
                </Row>
            </div>
        );
    }
    componentDidMount() {
        this.populateData();
    }
    async populateData() {
        this.setState({
            loading: true,
            etiquetasCore: await this.load_etiquetasCore(),
            calibres: await this.load_calibres(),
            cajasPorPaleta: await this.load_cajasPorPaleta(),
        }, async () => {
            this.setState({loading: false });
        });
    }

    async load_etiquetasCore() {
        const token = await authService.getAccessToken();
        const response = await fetch('api/etiquetasCore/', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        return await response.json();
    }
    async load_calibres() {
        const token = await authService.getAccessToken();
        const response = await fetch('api/calibres/', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        return await response.json();
    }
    async load_cajasPorPaleta() {
        const token = await authService.getAccessToken();
        const response = await fetch('api/cajasPorPaleta/', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        return await response.json();
    }
}